import React,{useState,useEffect,useRef} from 'react';
import { connect } from 'react-redux';
import {  StyledSubHeading } from '../CSS/style';
import { Button, Checkbox, Form, Input, Select, message } from 'antd';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { RBSLOOKUPMaster, MASTERDATASOURCE } from '../../../commons/api';
import { getMetaData, submitDataSource, getDeployHistory } from '../Utils/FormCalls';
const { Option } = Select;
const APIList = {
  getById: `${MASTERDATASOURCE.GET}`,
  getMetrics: `${RBSLOOKUPMaster.LookUpItemsGetById}`,
  createData: `${MASTERDATASOURCE.CREATE}`
};
const DataSourceMastersDetails = (props) => {
  const [formObject, setFormObject] = useState({});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [typeList, setTypeList] = useState({});
  const [subTypeList, setSubTypeList] = useState({});
  const [checkedVal, setCheckedVal] = useState('Active');
  const [selectedType, setSelectedType] = useState('');
  const edit = props && props.location && props.location.state && props.location.state.editTag
  ? props.location.state.editTag
  : null;
  const view = props && props.location && props.location.state && props.location.state.viewTag
  ? props.location.state.viewTag
  : null;
  const hRef = useRef();
  useEffect(() => {
    const fetchData = async () => {
      const DataSourceData = await getDeployHistory(APIList.getMetrics, 'LookupName', 'DATABASE TYPES');
      setTypeList(DataSourceData);
      const path = props.location.pathname.split('/rubus/RbsAnalytics/DataSourceMastersDetails/');
      const Id = path[1] || null;
      if (Id) {
        const data = await getMetaData(APIList.getById, 'Id', Id);
        const formObjectData = data[0] || {};
        const subType = await getDeployHistory(APIList.getMetrics, 'LookupName', formObjectData.Type);
        setCheckedVal(formObjectData.Status === 'Active' ? 'Active' : 'InActive');
        if (hRef.current) {
          hRef.current.setFieldsValue(formObjectData );
        }
        setFormObject(formObjectData);
        setSubTypeList(subType);
        setSelectedType(formObjectData.Type);
      }
    };
    fetchData();
  }, [props.location.pathname]);
  useEffect(() => {
    if (props.userProfile !== userProfile || props.translationCache !== translationCache) {
      setUserProfile(props.userProfile);
      setTranslationCache(props.translationCache);
    }
  }, [props.userProfile, props.translationCache]);
  const onFormSubmit = () => {
    hRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...hRef.current.getFieldsValue(),
          Status: checkedVal
        };
        let response = await submitDataSource(APIList.createData, values);
        //  const Id = response && response.Id ? response.Id : null;
        //   let metaData = await getMetaData(APIList.getById, "Id", Id);
        //   hRef.current &&
        //   hRef.current.setFieldsValue(metaData);
        // setState({ formObject: metaData });
        message.success(response && response.message ? translation(response.message) : '');
        props.navigate('/rubus/RbsAnalytics/DataSourceMastersList');
      })
      .catch(() => { });
  };
  const resetFields = () => {
    if (hRef.current) hRef.current.resetFields();
    setFormObject({});
    setCheckedVal('Active');
  };
  const onTypeSelect = async (value) => {
    const subType = await getDeployHistory(APIList.getMetrics, 'LookupName', value);
    setSubTypeList(subType);
    setSelectedType(value);
  };
  const onCheckboxChange = (e) => {
    setCheckedVal(e.target.checked ? 'Active' : 'InActive');
  };
  const translation = (keyword) => {
    return translationCache[keyword] || keyword;
  };
    const validateMessages = {
      required: translation('${label}') + translation('is required!')
    };
    const formItemLayout = { width: '100%', flex: '50%' };
    return (
      <>
        <StyledSubHeading theme={themeSettings}>
          {translation('DataSource Master')}
        </StyledSubHeading>
        <Form 
          name="ModelDetails"
          ref={hRef}
          autoComplete="off"
          initialValues={formObject}
          theme={themeSettings}
          layout="horizontal"
          labelCol={{ flex: '200px' }}
          labelAlign="right"
          onFinish={onFormSubmit}
          //onFinishFailed={onFinishFailed}
          disabled={view === true ? true : false}
          labelWrap
          validateMessages={validateMessages}
          wrapperCol={{ flex: 1 }}
        >
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item name="Id"></Form.Item>
            <Form.Item
              label={translation('DataSource Name')}
              name="Name"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Input
                disabled={formObject && formObject.Name ? true : false}
                style={{ width: '70%' }}
                placeholder={translation('Please Enter DataSource Name')}
              ></Input>
            </Form.Item>
            <Form.Item
              label={translation('DataSource Code')}
              name="Code"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Input
                disabled={formObject && formObject.Code ? true : false}
                style={{ width: '70%' }}
                placeholder={translation('Please Enter DataSource Code')}
              ></Input>
            </Form.Item>
            <Form.Item
              label={translation('Type')}
              name="Type"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Select
                disabled={formObject && formObject.Type ? true : false}
                style={{ width: '70%' }}
                placeholder={translation('Please Select Type')}
                onChange={onTypeSelect}
              >
                {typeList &&
                  Array.isArray(typeList) &&
                  typeList.map((type) => {
                    return (
                      <Option value={type.value} key={type.key}>
                        {type.key}
                      </Option>
                    );
                  })}{' '}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation('Sub Type')}
              name="SourceType"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Select
                disabled={formObject && formObject.SourceType ? true : false}
                style={{ width: '70%' }}
                placeholder={translation('Please Select Sub Type')}
              >
                {subTypeList &&
                  Array.isArray(subTypeList) &&
                  subTypeList.map((subType) => {
                    return (
                      <Option value={subType.value} key={subType.key}>
                        {subType.key}
                      </Option>
                    );
                  })}{' '}
              </Select>
            </Form.Item>
            {selectedType && selectedType !== undefined ? (
              <>
                {selectedType && selectedType === 'DATABASE' ? (
                  <>
                    <Form.Item
                      label={translation('DataBase')}
                      name="DataBase"
                      rules={[{ required: true }]}
                      style={formItemLayout}
                    >
                      <Input
                        disabled={formObject && formObject.DataBase ? true : false}
                        style={{ width: '70%' }}
                        placeholder={translation('Please Enter DataBase')}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      label={translation('Host')}
                      name="Host"
                      rules={[{ required: true }]}
                      style={formItemLayout}
                    >
                      <Input
                        disabled={formObject && formObject.Host ? true : false}
                        style={{ width: '70%' }}
                        placeholder={translation('Please Enter Host')}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      label={translation('User Name')}
                      name="UserName"
                      rules={[{ required: true }]}
                      style={formItemLayout}
                    >
                      <Input
                        disabled={formObject && formObject.UserName ? true : false}
                        style={{ width: '70%' }}
                        placeholder={translation('Please Enter User Name')}
                      ></Input>
                    </Form.Item>
                    <Form.Item
                      label={translation('Password')}
                      name="Password"
                      rules={[{ required: true }]}
                      style={formItemLayout}
                    >
                      <Input.Password
                        disabled={formObject && formObject.Password ? true : false}
                        style={{ width: '70%' }}
                        placeholder={translation('Please Enter Password')}
                      ></Input.Password>
                    </Form.Item>
                    <Form.Item
                      label={translation('Port')}
                      name="Port"
                      rules={[{ required: true }]}
                      style={formItemLayout}
                    >
                      <Input
                        disabled={formObject && formObject.Port ? true : false}
                        style={{ width: '70%' }}
                        placeholder={translation('Please Enter Port')}
                      ></Input>
                    </Form.Item>
                  </>
                ) : (
                  <Form.Item
                    label={translation('File Path')}
                    name="FilePath"
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Input
                      disabled={formObject && formObject.FilePath ? true : false}
                      style={{ width: '70%' }}
                      placeholder={translation('Please Enter File Path')}
                    ></Input>
                  </Form.Item>
                )}
              </>
            ) : null}
            <Form.Item label={translation('Active')} name="Status" style={formItemLayout}>
              <Checkbox
                checked={checkedVal === 'Active' ? true : false}
                onClick={(e) => onCheckboxChange(e)}
              />
            </Form.Item>
          </div>
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Form.Item>
              <Button
                style={{ marginRight: 8 }}
                theme={themeSettings}
                type="primary"
                htmlType="submit"
                data-testid="submitButton"
              >
                {edit ? translation('Update') : translation('Submit')}
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                style={{ marginRight: 8 }}
                theme={themeSettings}
                type="primary"
                danger
                onClick={() => resetFields()}
              >
                {translation('Reset')}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </>
    );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(DataSourceMastersDetails);
